import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getFormValues } from 'redux-form';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { ProgressTracker, Container, Button, H4, ConfirmationBox } from '../../components/index.js';
import { createServiceAction } from '../../util/actionHelper.js';
import { displaySubmitButtonQrf, displayClearButtonQrf, clearFormValueQRF, attachmentQrf } from '../../actions/qrfActions';
import { isLabUser, isRslUser, isNloUser, selectUserDetails } from '../../reducers/authReducer.js';
import { checkAndRedirectIfBlocked } from '../../util/routeProtection.js';

import TrfInfo from './trfInfo/TrfInfo';
import QrfInfo from './qrfInfo/QrfInfo'; // use for old qrf flow
import ReviewAndSubmitInfo from './reviewAndSubmitInfo/ReviewAndSubmitInfo';
import Remediation from './qrfInfo/Remediation.js';

class Qrf extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitModal: false,
      status: null,
      stepState: 0
    };
    this.hidden = {
      display: 'none'
    };
    this.handleQrfSubmit = this.handleQrfSubmit.bind(this);
    this.confirmationBoxOpen = this.confirmationBoxOpen.bind(this);
    this.currentStep = this.currentStep.bind(this);
    this.cancelQrf = this.cancelQrf.bind(this);
  }

  componentDidMount() {
    const { location, getTrfDetails, clearFormValueQRF, history, isLabUser, isRslUser, isNloUser, userDetails } = this.props;
    
    // Check if user should be blocked - uses centralized route protection
    if (checkAndRedirectIfBlocked({ userDetails, isRslUser, isNloUser, isLabUser, history })) {
      return;
    }
    
    getTrfDetails(location.state && location.state.trfId);
    clearFormValueQRF();
  }

  onClickNext = () => {
    this.setState(prevState => ({
      stepState: prevState.stepState + 1
    }));
    this.clickNext();
  };

  onClickPrevious = () => {
    this.setState(prevState => ({
      stepState: prevState.stepState - 1
    }));
    this.clickPrevious();
  };

  handleQrfSubmit = QrfInfor => {
    const { submitQrf, updateQrf, history, location, attachmentNew } = this.props;
    const requestObject = {};
    requestObject.trfId = location.state.trfId;
    requestObject.location = QrfInfor.affectedMaterial;
    requestObject.quantity = QrfInfor.materialAffectedQty;
    requestObject.materialWorth = QrfInfor.materialWorth;
    requestObject.leftFacility = QrfInfor.affectedMaterialLeft;
    requestObject.factories = QrfInfor.factoryList;
    requestObject.isAffectedKidProduct = QrfInfor.affectedMaterialForKid;
    requestObject.nextStep = QrfInfor.immediateStep;
    requestObject.attachment = attachmentNew;
  if (QrfInfor.qrfId) {
    requestObject.qrfId = QrfInfor.qrfId;
 updateQrf(requestObject, history);
  } else {
    submitQrf(requestObject, history);
  }
};
  handleRemediationSubmit = QrfInfor => {  
    const { submitQrf, updateQrf, history, location, attachmentNew, trfDetail,trfData } = this.props;  
    const requestObject = {};
    requestObject.trfId = location.state.trfId;;
    requestObject.quantity = QrfInfor.materialAffectedQty;
    requestObject.materialWorth = QrfInfor.materialWorth;
    requestObject.leftFacility = QrfInfor.affectedMaterialLeft;
    requestObject.futureProduction = QrfInfor.futureProduction;
    requestObject.PDCA = QrfInfor.PDCA;
    requestObject.failureDesc = QrfInfor.failureDesc;
    requestObject.correctiveAction = QrfInfor.correctiveAction;
    requestObject.rootCause = QrfInfor.rootCause;
    requestObject.proposedCorrectiveAction = QrfInfor.proposedCorrectiveAction;
    requestObject.dateOfCompletion = QrfInfor.proposedCorrectiveAction === "Yes" ? null:QrfInfor.dateOfCompletion;
    requestObject.attachment = attachmentNew;
    requestObject.RSLNo = trfDetail.data.trfDetails.RSLNo;
    if (trfData.data.qrfDetails && trfData.data.qrfDetails.qrfId !== null) {
      requestObject.qrfId = trfData.data.qrfDetails.qrfId;
      requestObject.frfId = QrfInfor.frfId;
      updateQrf(requestObject, history);
    } else {
      submitQrf(requestObject, history);
    }
  }

  confirmationBoxOpen = (modalopen, status) => {
    this.setState({ submitModal: true, status });
  };

  closeSubmitModal = () => {
    this.setState({ submitModal: false });
  };

  cancelQrf = () => {
    const { history, attachment } = this.props;
    while(attachment.length>0){
      attachment.pop()
    }
    history.push('/');
  };

  currentStep = (step) => {
    this.setState({ stepState: step });
  }
  render() {
    const {
      QrfInfor,
      errorClassName,
      shouldDisplaySubmit,
      shouldDisplayClear,
      displaySubmitButtonQrf,
      displayClearButtonQrf,
      qrfDetails,
      qrfDetailsForEdit,
      isLabUser,
      attachmentQrf,
      attachment,
      trfDetail,
      location,
      QrfInfoOld,
      qrfDetailsForEditOld,
      qrfDetailsOld
    } = this.props;
    const { submitModal, status, stepState } = this.state;
    const remediation = trfDetail && (location.state.action === "Awaiting Nike Response" && trfDetail.data.trfDetails.statusValue === 'FRF Submitted') ? false : true;
    const steps = [
      {
        name: 'TRF INFORMATION',
        component: (
          <TrfInfo
            displayClearButtonQrf={displayClearButtonQrf} 
            displaySubmitButtonQrf={displaySubmitButtonQrf}
          />
        )
      },
      {
        name: remediation ?'REMEDIATION INFORMATION' :'QRF INFORMATION',
        component: (
          remediation ? <Remediation
            attachmentQrf={attachmentQrf}
            displaySubmitButtonQrf={displaySubmitButtonQrf}
            displayClearButtonQrf={displayClearButtonQrf}
            {...(qrfDetailsForEdit.qrfId ? { initialValues: qrfDetailsForEdit } : { initialValues: qrfDetails })}
            successFill={typeof errorClassName !== 'undefined' ? errorClassName[1] : true}
            attachment={attachment}
          /> :
           <QrfInfo
          attachmentQrf={attachmentQrf}
            displaySubmitButtonQrf={displaySubmitButtonQrf}
            displayClearButtonQrf={displayClearButtonQrf}
            {...(qrfDetailsForEditOld.qrfId ? { initialValues: qrfDetailsForEditOld } : { initialValues: qrfDetailsOld })}
            successFill={typeof errorClassName !== 'undefined' ? errorClassName[1] : true}
            attachment={attachment}
          />    
        )
      },
      {
        name: 'REVIEW & SUBMIT',
        component: (
          <ReviewAndSubmitInfo
            displayClearButtonQrf={displayClearButtonQrf}
            displaySubmitButtonQrf={displaySubmitButtonQrf}
            {...QrfInfor}
            attachment={attachment}
          />
        )
      }
    ];
    return (
      <div className="page-align-fixed-items">
        {!isLabUser ? (
          <div className="TRFpage">
            <div section="true" className="prevent-scroll top-scroll-fix">
              <H4 className="text-color-accent u-bold page-title-has-back sub-heading p2-bottom-sm">
                REMEDIATION FORM
              </H4>
            </div>
            <div section="true" className="clear-margin progress-tracker-align">
              <ProgressTracker
                steps={steps}
                errorClassName={errorClassName}
                clickNext={clickNext => (this.clickNext = clickNext)}
                clickPrevious={clickPrevious => (this.clickPrevious = clickPrevious)}
                currentStepNumber={this.currentStep}
              />
            </div>
            <Container section={true} className="prevent-scroll bottom-scroll-fix bottom-section remove-margin">
              <Button
                style={stepState === 0 ? this.hidden : {}}
                className="ncss-btn-secondary-dark u-bold progresstracker-prevoius-button trf-button-selected"
                onClick={() => this.onClickPrevious('previous')}
              >
                PREVIOUS
              </Button>
              {shouldDisplaySubmit && (
                <span>
                  {errorClassName && errorClassName.every(element => element === false) ? (
                    <span>
                      <Button
                        className="ncss-btn-primary-dark u-bold submit-button-enable trf-button-selected"
                        onClick={() => this.confirmationBoxOpen(true, 'submit')}
                      >
                       {qrfDetails.proposedCorrectiveAction === 'Yes' ? "SUBMIT AND PROCEDE TO RE-TEST" : "SUBMIT" } 
                      </Button>
                    </span>
                  ) : (
                    <Button className="ncss-btn-primary-dark disabled u-bold submit-button trf-button-selected">
                      SUBMIT
                    </Button>
                  )}
                </span>
              )}
              {shouldDisplayClear && (
                <Button
                  className="ncss-btn-secondary-dark u-bold secondary-button trf-button-selected"
                  onClick={() => this.confirmationBoxOpen(true, 'clear')}
                  background="bg-dark-grey"
                >
                  CLEAR
                </Button>
              )}
              <Button
                style={stepState === 2 ? this.hidden : {}}
                className="ncss-btn-secondary-dark u-bold progresstracker-next-button trf-button-selected"
                onClick={() => this.onClickNext('next')}
              >
                NEXT
              </Button>
            </Container>
            <ConfirmationBox
              message={
                status === 'submit'
                  ? remediation ?'Are you sure you want to submit the REMEDIATION ?' : 'Are you sure you want to submit the QRF ?'
                  : remediation ?'Are you sure you want to clear the REMEDIATION ? ': 'Are you sure you want to clear the QRF ?'
              }
              submitModal={submitModal}
              submitValue={
                status === 'submit'
                  ? () => {
                   remediation? this.handleRemediationSubmit(QrfInfor) : this.handleQrfSubmit(QrfInfoOld);
                  }
                  : () => this.cancelQrf()
              }
              closeModal={this.closeSubmitModal}
            />
          </div>
        ) : (
          <div className="pagenotFound">Error! Page you are looking for is not found</div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    QrfInfor: getFormValues('Remediation')(state), // here 'qrfinfo' is the name you have given your redux form
    QrfInfoOld: getFormValues('QrfInfo')(state),
    errorClassName: state.qrf.errorClassName,
    trfDetail: state.qrf.trfDetail,
    trfData: state.trf.trfData,
    qrfDetails: {
      qrfId: '',
      factoryList: get(state, `form.Remediation.values.factoryList`, ''),
      affectedMaterialLeft: get(state, `form.Remediation.values.affectedMaterialLeft`, ''),
      affectedMaterial: get(state, `form.Remediation.values.affectedMaterial`, ''),
      materialAffectedQty: get(state, `form.Remediation.values.materialAffectedQty`, ''),
      materialWorth: get(state, `form.Remediation.values.materialWorth`, ''),
      futureProduction: get(state, `form.Remediation.values.futureProduction`, ''),
      frfId: get(state.frf.trfDetail, `data.frfDetails.frfId`, ''),
      PDCA: get(state, `form.Remediation.values.PDCA`, get(state.qrf.trfDetail, `data.frfDetails.PDCA`, '')),
      failureDesc: get(state, `form.Remediation.values.failureDesc`, get(state.qrf.trfDetail, `data.frfDetails.failureDesc`, '')),
      dateOfCompletion: get(state, `form.Remediation.values.dateOfCompletion`,null),
      correctiveAction: get(state, `form.Remediation.values.correctiveAction`, get(state.qrf.trfDetail, `data.frfDetails.correctiveAction`, '')),
      rootCause: get(state, `form.Remediation.values.rootCause`, get(state.qrf.trfDetail, `data.frfDetails.rootCause`, '')),
      guideYes: get(state, `form.Remediation.values.guideYes`,'' ),
      guideNo: get(state, `form.Remediation.values.guideNo`, ''),
      futureProductYes: get(state, `form.Remediation.values.futureProductYes`, ''),
      proposedCorrectiveAction: get(state, `form.Remediation.values.proposedCorrectiveAction`, '')   
    },
    qrfDetailsForEdit: {
      qrfId: get(state.qrf.trfDetail, `data.qrfDetails.qrfId`, ''),
      affectedMaterialLeft: get(state, `form.Remediation.values.affectedMaterialLeft`, get(state.qrf.trfDetail, `data.qrfDetails.leftFacility`, '')),
      affectedMaterial: get(state, `form.Remediation.values.affectedMaterial`, get(state.qrf.trfDetail, `data.qrfDetails.location`, '')),
      materialAffectedQty: get(state, `form.Remediation.values.materialAffectedQty`, get(state.qrf.trfDetail, `data.qrfDetails.quantity`, '')),
      materialWorth: get(state, `form.Remediation.values.materialWorth`, get(state.qrf.trfDetail, `data.qrfDetails.materialWorth`, '')),
      futureProduction: get(state, `form.Remediation.values.futureProduction`, get(state.qrf.trfDetail, `data.qrfDetails.futureProduction`, '')),
      //futureProduction: get(state, `form.Remediation.values.futureProduction`, get(state.qrf.trfDetail, `data.qrfDetails.futureProduction`, '') === null ? null : get(state.qrf.trfDetail, `data.qrfDetails.futureProduction`, '')),
      frfId: get(state.qrf.trfDetail, `data.frfDetails.frfId`, ''),
      PDCA: get(state, `form.Remediation.values.PDCA`, get(state.qrf.trfDetail, `data.frfDetails.PDCA`, '')),
      failureDesc: get(state, `form.Remediation.values.failureDesc`, get(state.qrf.trfDetail, `data.frfDetails.failureDesc`, '')),
      //dateOfCompletion: get(state, `form.Remediation.values.dateOfCompletion`, (get(state.qrf.trfDetail, `data.frfDetails.dateOfCompletion`, '') && new Date(get(state.frf.trfDetail, `data.frfDetails.dateOfCompletion`, '')))),
      dateOfCompletion: get(state, `form.Remediation.values.dateOfCompletion`,(get(state.qrf.trfDetail, `data.frfDetails.dateOfCompletion`, '') && new Date(get(state.qrf.trfDetail, `data.frfDetails.dateOfCompletion`, '')))),
      
      correctiveAction: get(state, `form.Remediation.values.correctiveAction`, get(state.qrf.trfDetail, `data.frfDetails.correctiveAction`, '')),
      rootCause: get(state, `form.Remediation.values.rootCause`, get(state.qrf.trfDetail, `data.frfDetails.rootCause`, '')),
      guideYes: get(state, `form.Remediation.values.guideYes`, get(state.qrf.trfDetail, `data.qrfDetails.leftFacility`, '') === 'Yes'? true : false),
      guideNo: get(state, `form.Remediation.values.guideNo`, get(state.qrf.trfDetail, `data.qrfDetails.leftFacility`, '') === 'No'? true : false),
      futureProductYes: get(state, `form.Remediation.values.futureProductYes`, get(state.qrf.trfDetail, `data.qrfDetails.futureProduction`, '') === 'Yes'? true : false),
      proposedCorrectiveAction: get(state, `form.Remediation.values.proposedCorrectiveAction`, get(state.qrf.trfDetail, `data.frfDetails.proposedCorrectiveAction`, '')),
      // proposedCorrectiveAction: get(state, `form.Remediation.values.proposedCorrectiveAction`, 
      //   get(state.qrf.trfDetail, `data.frfDetails.dateOfCompletion`, '')=== null ? null : 'No'),
    },
    qrfDetailsOld:{
      qrfId:'',
      factoryList:  get(state, `form.QrfInfo.values.factoryList`, ''),
      affectedMaterialLeft: get(state, `form.QrfInfo.values.affectedMaterialLeft`, ''),
      affectedMaterialForKid: get(state, `form.QrfInfo.values.affectedMaterialForKid`, ''),
      affectedMaterial: get(state, `form.QrfInfo.values.affectedMaterial`, ''),
      materialAffectedQty: get(state, `form.QrfInfo.values.materialAffectedQty`, ''),
      materialWorth: get(state, `form.QrfInfo.values.materialWorth`, ''),
      immediateStep:get(state, `form.QrfInfo.values.immediateStep`, ''),

    },
    qrfDetailsForEditOld: {
      qrfId: get(state.qrf.trfDetail, `data.qrfDetails.qrfId`, ''),
      factoryList:  get(state, `form.QrfInfo.values.factoryList`, get(state.qrf.trfDetail, `data.qrfDetails.factories`, '')),
      affectedMaterialLeft:  get(state, `form.QrfInfo.values.affectedMaterialLeft`, get(state.qrf.trfDetail, `data.qrfDetails.leftFacility`, '')),
      affectedMaterialForKid:  get(state, `form.QrfInfo.values.affectedMaterialForKid`, get(state.qrf.trfDetail, `data.qrfDetails.isAffectedKidProduct`, '')),
      affectedMaterial:  get(state, `form.QrfInfo.values.affectedMaterial`, get(state.qrf.trfDetail, `data.qrfDetails.location`, '')),
      materialAffectedQty:  get(state, `form.QrfInfo.values.materialAffectedQty`, get(state.qrf.trfDetail, `data.qrfDetails.quantity`, '')),
      materialWorth:  get(state, `form.QrfInfo.values.materialWorth`, get(state.qrf.trfDetail, `data.qrfDetails.materialWorth`, '')),
      immediateStep:  get(state, `form.QrfInfo.values.immediateStep`, get(state.qrf.trfDetail, `data.qrfDetails.nextStep`, '')),
      
    },
    attachment: state.qrf.attachment,
    attachmentNew: state.qrf.attachmentNew,
    shouldDisplaySubmit: state.qrf.shouldDisplaySubmit,
    shouldDisplayClear: state.qrf.shouldDisplayClear,
    isLabUser: isLabUser(state),
    isRslUser: isRslUser(state),
    isNloUser: isNloUser(state),
    userDetails: selectUserDetails(state),
    qrfData: state.qrf.qrfData,
  };
}

const mapDispatchToProps = dispatch => ({
  submitQrf: (data, history) => {
    dispatch(createServiceAction('qrfSubmit', 'submitted')({ ...data, history }));
  },
  updateQrf: (data, history) => {
    dispatch(createServiceAction('qrfUpdate', 'submitted')({ ...data, history }));
  },
  getTrfDetails: data => {
    dispatch(createServiceAction('trfDetailsForQrf', 'requested')(data));
  },
  displaySubmitButtonQrf: isOpen => {
    dispatch(displaySubmitButtonQrf(isOpen));
  },
  displayClearButtonQrf: isOpen => {
    dispatch(displayClearButtonQrf(isOpen));
  },
  clearFormValueQRF: () => {
    dispatch(clearFormValueQRF());
  },
  attachmentQrf: data => {
    dispatch(attachmentQrf(data));
  },

});
  

Qrf.propTypes = {
  getTrfDetails: PropTypes.func,
  displaySubmitButtonQrf: PropTypes.func,
  shouldDisplaySubmit: PropTypes.bool,
  displayClearButtonQrf: PropTypes.func,
  shouldDisplayClear: PropTypes.bool,
  clearFormValueQRF: PropTypes.func,
  isLabUser: PropTypes.bool,
  attachmentQrf: PropTypes.func,
  attachment: PropTypes.array,
  attachmentNew:PropTypes.array,
  trfDetails: PropTypes.object,
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Qrf)
);